/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Mixdown_LabelInputs */

const en_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Mixdown`)
};

const fr_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter le mixdown`)
};

const de_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Mixdown`)
};

const it_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta Mixdown`)
};

const ru_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспортная смесь`)
};

const es_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación Mixdown`)
};

const zh_cn2_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口混合`)
};

const ja_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミックスダウンのエクスポート`)
};

const hi_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सपोर्ट मिक्सडाउन`)
};

const pt_pt2_audio_description_export_mixdown_label = /** @type {(inputs: Audio_Description_Export_Mixdown_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixdown de exportação`)
};

/**
* | output |
* | --- |
* | "Export Mixdown" |
*
* @param {Audio_Description_Export_Mixdown_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_mixdown_label = /** @type {((inputs?: Audio_Description_Export_Mixdown_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Mixdown_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_mixdown_label(inputs)
	if (locale === "de") return de_audio_description_export_mixdown_label(inputs)
	if (locale === "it") return it_audio_description_export_mixdown_label(inputs)
	if (locale === "ru") return ru_audio_description_export_mixdown_label(inputs)
	if (locale === "es") return es_audio_description_export_mixdown_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_mixdown_label(inputs)
	if (locale === "ja") return ja_audio_description_export_mixdown_label(inputs)
	if (locale === "hi") return hi_audio_description_export_mixdown_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_mixdown_label(inputs)
	return en_audio_description_export_mixdown_label(inputs)
});